import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../pipes/pipes.module';
import { QrScannerComponent } from './qr-scanner/qr-scanner.component';
import { DaumComponent } from './daum/daum.component';
import { InputModule } from './input/input.module';
import { LayoutModule } from './layout/layout.module';
import { ModalModule } from './modal/modal.module';
import { NativeModule } from './native/native.module';
import { CustomVideoPlayerComponent } from './custom-video-player/custom-video-player.component';


@NgModule({
  declarations: [
    DaumComponent,
    QrScannerComponent,
    CustomVideoPlayerComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule,
    RouterModule,
    InputModule,
    LayoutModule,
    ModalModule,
    NativeModule
  ],
  exports: [
    DaumComponent,
    QrScannerComponent,
    CustomVideoPlayerComponent,
    InputModule,
    LayoutModule,
    ModalModule,
    NativeModule
  ]
})
export class ComponentModule { }
